import React from 'react';
import { useParams } from 'react-router-dom';
import './ProfilePage.css';

import ProfileBanner from './ProfileBanner';
import TopPicksRow from './TopPicksRow';
import ContinueWatching from './ContinueWatching';
import MoreLikeThis from './MoreLikeThis';
type ProfileType = 'recruiter' | 'developer' | 'stalker';

const developerBackgroundGif = 'https://media1.tenor.com/m/Su2kZtYwoaQAAAAd/the-social.gif';
const stalkerBackgroundGif = 'https://media1.tenor.com/m/4apQClorlQkAAAAd/truman-show.gif';

const profileBackgroundGifs: Record<ProfileType, string> = {
  recruiter: 'https://i.giphy.com/media/v1.Y2lkPTc5MGI3NjExOTZ5eWwwbjRpdWM1amxyd3VueHhteTVzajVjeGZtZGJ1dDc4MXMyNCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9dg/16u7Ifl2T4zYfQ932F/giphy.gif',
  developer: 'https://i.giphy.com/media/v1.Y2lkPTc5MGI3NjExNGNidDl5emZpejY2eGFxa2I4NW0zZGNpbWRlbnBrZ3N2dWhhbzM1MyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/TFPdmm3rdzeZ0kP3zG/giphy.gif',
  stalker: 'https://i.giphy.com/media/v1.Y2lkPTc5MGI3NjExc28yMjMyZmJ6eWtxbmNwdDV6cXk4dWZmcjFhZms2cXBjN2h5ZDJjeSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/QjZXUBUr89CkiWLPjL/giphy.gif',
};

const ProfilePage: React.FC = () => {
  const { profileName } = useParams<{ profileName: string }>();

  const profile = ['recruiter', 'developer', 'stalker'].includes(profileName!)
    ? (profileName as ProfileType)
    : 'recruiter';
  const backgroundGif = profile === 'developer'
    ? developerBackgroundGif
    : profile === 'stalker'
      ? stalkerBackgroundGif
      : profileBackgroundGifs[profile];

  return (
    <>
      <div
        className={`profile-page ${profile === 'developer' ? 'developer-profile-page' : profile === 'stalker' ? 'stalker-profile-page' : ''}`}
        style={{ backgroundImage: `url(${backgroundGif})` }}
      >
        <ProfileBanner
        />
      </div>
      <TopPicksRow profile={profile} />
      <ContinueWatching profile={profile} />
      <MoreLikeThis profile={profile} />
    </>
  );
};

export default ProfilePage;
